import { Pipe, PipeTransform } from '@angular/core'
@Pipe({
  name: 'toThousands',
  pure: true,
})
export class ToThousandsPipe implements PipeTransform {
  transform(val: string | number | null): string {
    const toThousands = (num = 0) => {
      return num.toString().replace(/\d+/, function (n) {
        return n.replace(/(\d)(?=(?:\d{3})+$)/g, '$1,')
      })
    }
    return toThousands(val == '' || val == undefined || val == null ? 0 : +val)
  }
}
